<template>
    <div class="gift-course-items__container__item-container__content">

        <div class="card border-0">
            <div class="rounded-3 clickable m-b-10">
                <a @click="onClick(course)">
                    <div class="image-container">
                        <img v-if="course.course_thumb_image" class="rounded"
                             :src="course.course_thumb_image"
                             :alt="course.name">
                        <img class="rounded" v-else
                             :src="course.course_image"
                             :alt="course.name">
                    </div>
                </a>
            </div>
            <div class="card-body">
                <div class="col-12">
                    <a :href="course.company.url"
                       class="text-capitalize font-12 fw-400 text-truncate w-100 d-inline-block text-color-black">
                        {{course.company.name}}
                    </a>
                    <h5 class="font-16 fw-600 clickable text-color-black text-nowrap text-truncate" v-text="course.seo_name"></h5>
                    <p class="card-text font-12 text-uppercase m-0 text-color-black text-nowrap text-truncate" v-text="course.address"></p>
                    <span class="badge badge-pill course-badge-info" v-if="course.sport"
                          v-text="course.sport.name"></span>
                </div>
            </div>
            <div class="text-center m-t-20">
                <button type="button"
                        class="btn btn-primary text-uppercase text-white font-14 fw-600" data-toggle="modal"
                        data-target="#giftCardModal">
                    Scegli la carta
                </button>
                <br>
                <a href="#" :href="hrefCourse(course)" class="text-color-orango font-14 clickable" target="_blank">Scopri
                    il corso</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            data: Object
        },
        data() {
            return {
                course: this.data,
                show: false
            }
        },
        methods: {
            onClick(course) {
                location.href = `/corsi/${course.slug}`
            },
            onMouseOver() {
                this.$set(this, 'show', true)
            },
            onMouseLeave() {
                this.$set(this, 'show', false)
            },
            hrefCourse(course) {
                return `/corsi/${course.slug}`;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gift/GiftCourseItem.vue